import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Upload } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';
import { FileDownloaderComponent } from '../file-downloader/file-downloader.component';
import { FileEditorComponent } from '../file-editor/file-editor.component';

@Component({
  selector: 'xmed-files-list-view',
  standalone: true,
  imports: [
    DatePipe,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    XmedicalUiModule,
    FileDownloaderComponent,
    FileEditorComponent
  ],
  templateUrl: './files-list-view.component.html',
  styleUrl: './files-list-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilesListViewComponent {
  uploads = input<Upload[]>([]);
  displayedColumns = input<string[]>(['name', 'uploaded', 'size', 'tags', 'actions']);

  dataSource = computed(() => {
    const sorted = [...this.uploads()].sort((a, b) => {
      const dateDiff = new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime();
      if (dateDiff !== 0) return dateDiff;
      return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
    });
    return new MatTableDataSource(sorted);
  });
}
